import { Component } from '@angular/core';

@Component({
    selector: 'footer-app',
    templateUrl: './_footer.html',
    standalone: false
})
export class FooterComponent {
  displayYear = new Date().getFullYear();
}
